import { Component } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { filter, first } from 'rxjs';
import { CloudinaryService } from '../../services/cloudinary.service';
import { SeoService } from '../../services/seo.service';
import { MenuStateService } from '../../services/menu-state.service';
import { EcommerceService } from '../../services/ecommerce.service';

@Component({
  selector: 'app-nav-mobile',
  standalone: false,
  templateUrl: './nav-mobile.component.html',
  styleUrl: './nav-mobile.component.css'
})
export class NavMobileComponent {
menus: { [key: string]: boolean } = {
    motos: false,
    lineafuerza: false,
    repuestos: false,
    servicios: false,
    novedades: false,
    nosotros: false,
    sucursales: false,
    contactanos: false,
    user: false
  };
dataCompleta:any=[];
  grupoModelos:any=[];
  itemsGrupo:any=[];
  active:any;
  viewModelsBlock:boolean=false;
  search:any;
  viewSearchBlock:boolean=false;
  viewModelsCars:boolean = false;
  orientationTab;
  nombreGrupo:any;
  menuPrincipal:boolean=false;
  menuicontop:any = 'https://res.cloudinary.com/toyosa-sa/image/upload/v1733317324/production/toyota-bolivia/web/assets/icons/header/flecha_abierto.svg';
  menuicondown:any = 'https://res.cloudinary.com/toyosa-sa/image/upload/v1733317323/production/toyota-bolivia/web/assets/icons/header/flecha_cerrado.svg';
  menuOpen = false;
  imgexternallinkblack:any;
  imguserlogin:any = 'https://res.cloudinary.com/toyosa-sa/image/upload/v1742311007/production/toyota-bolivia/web/assets/icons/header/user-login.png';
  // Íconos personalizados para cada menú
  menuIcons: { [key: string]: { abierto: string; cerrado: string } } = {
    motos: { abierto: this.menuicontop, cerrado: this.menuicondown },
    lineafuerza: { abierto: this.menuicontop, cerrado: this.menuicondown },
    repuestos: { abierto: this.menuicontop, cerrado: this.menuicondown },
    servicios: { abierto: this.menuicontop, cerrado: this.menuicondown },
    novedades: { abierto: this.menuicontop, cerrado: this.menuicondown },
    nosotros: { abierto: this.menuicontop, cerrado: this.menuicondown },
    sucursales: { abierto: this.menuicontop, cerrado: this.menuicondown },
    contactanos: { abierto: this.menuicontop, cerrado: this.menuicondown },
    user: { abierto: this.menuicontop, cerrado: this.menuicondown },
  };
  menuExternalOpen = false;
  /* info del usuario*/
  public userData: any;
  public userJson:any;
  nombreUsuario:string="";
  cantidadCarrito:any;

  constructor(private router: Router, private cloudinaryService: CloudinaryService, private seoService: SeoService, private menuStateService: MenuStateService, private eCommerceService: EcommerceService) {
      this.active = null;
      this.orientationTab = 'vertical';
      this.viewModelsCars = false;
      // Escuchar cambios en el estado del menú
      this.menuStateService.menuState$.subscribe((state) => {
        this.menuOpen = state;
        if (this.menuOpen) {
          
        }else {
          this.noViewMenuPrincipal();
        }
      });
  }
  loadImage() {
    this.imgexternallinkblack = this.cloudinaryService.getImageUrl('https://res.cloudinary.com/toyosa-sa/image/upload/v1721914261/production/toyota-bolivia/web/assets/icons/external-link-black.svg', {
      width: 14,
      height: 14,
      fetch_format: 'auto',
      quality: 'auto'
    });
  }

  ngOnInit(): void {
    this.verificandoUsuario();
    this.router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      // Aquí actualizas el contenido de tu componente o haces cualquier acción adicional
      //console.log('Ruta actual:', event.urlAfterRedirects);
      this.verificandoUsuario();
      
    });
  }

  verificandoUsuario() {
    localStorage.removeItem("toyocarrito");
    this.userData = localStorage.getItem('userPlataformaTY');
    this.userJson = JSON.parse(this.userData);

    if(this.userJson != null){
        this.nombreUsuario = "Hola, "+(this.userJson['nombre'].split(' ')[0]);
        this.eCommerceService.verCarrito().pipe(first()).subscribe(
          data => {
            if(data.detalle_productos) {
              if(data.detalle_productos.length > 0) {
                localStorage.setItem('toyocarrito', JSON.stringify(data));
                this.cantidadCarrito = data.detalle_productos.length;
                //this.sucursalCarrito = data.detalle_productos[0].nombre_sucursal;
              } else {
              }
            }
            
          }, error => console.log(error)
        );
    } else {
      this.nombreUsuario = "Toyosa";
    }
  }
  
toggleMenu() {
  this.menuOpen = !this.menuOpen;
}

  backModels() {
    this.abrirSubMenu(".");
  }
  backCars() {
    this.itemsGrupo = [];
    this.viewModelsBlock = true;
    this.viewModelsCars = false;
  }
  viewMenuPrincipal() {
    this.menuPrincipal = true;
    this.search = '';
  }
  noViewMenuPrincipal() {
    this.menuPrincipal = false;
  }
  viewModels() {
    if(this.viewModelsBlock){
      this.viewModelsBlock = false;
    } else {
      this.viewModelsBlock = true;
    }
  }

  noViewModels() {
    this.viewModelsBlock = false;
  }
  abrirSubMenu(nombre: string): void {
    Object.keys(this.menus).forEach(key => {
      this.menus[key] = key === nombre ? !this.menus[key] : false;
    });
  }

  cerrarSubMenu(menu: string): void {
    this.menus[menu] = false;
  }

  isMenuOpen(menu: string): boolean {
    return this.menus[menu];
  }

  getMenuIcon(menu: string): string {
    return this.isMenuOpen(menu) ? this.menuIcons[menu].abierto : this.menuIcons[menu].cerrado;
  }
}
